import { t } from '../i18n/i18n'
import { handleMessage } from './stateHelper'
import { IDataContext } from '../interfaces/IDataContext'
import { api } from './apiHelper'

export const downloadTermsAndConditions = async (dataContext: IDataContext) => {
   try {
      const response = await api().getTermsAndConditions()
      const termsAndConditions = await response.blob()

      downloadFile(termsAndConditions, `${t('TermsAndConditions')}.pdf`)

      handleMessage(dataContext.setRootState, 'success', t('SuccessfullyDownloadedTermsAndConditions'))
   } catch (error) {
      handleMessage(dataContext.setRootState, 'error', t('CouldNotDownloadTermsAndConditions'))
   }
}

export const downloadFile = (blob: Blob, filename: string) => {
   const url = URL.createObjectURL(blob)
   const link = document.createElement('a')

   link.href = url
   link.download = filename
   document.body.appendChild(link)
   link.click()

   URL.revokeObjectURL(url)
   link.remove()
}
